import { styled } from '@mui/styles';
import { Box } from '@mui/material';

export const HeaderBox = styled(Box)(({ theme }) => ({
  minHeight: 108,
}));
